// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"cd9d2d35","296":"427156cd","375":"3724ffd8","535":"7ff50ed0","572":"6dc95195","670":"18a9ad9e","679":"e542922b","793":"0afb1be1","825":"a64bf640","904":"bc861e3d","906":"75cbeb7b"}[chunkId] + ".chunk.js";
};